// Angular libraries
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from 'src/environments/environment';

// 3rd party libraries
import * as Sentry from "@sentry/angular";

// API-related
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

// App code
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Services
import { GlobalErrorHandlerService } from '@services/global-error-handler.service';

import { Router } from '@angular/router';
import { NgxStripeModule } from 'ngx-stripe';
import { SharedModule } from './shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
    domain: window.location.hostname
  },
  palette: {
    popup: {
      background: '#fff',
    },
    button: {
      background: '#90EE90'
    }
  },
  theme: 'classic',
  type: 'opt-out',
  position: 'bottom-right',
  content:{
    message: "This website uses cookies to ensure you get the best experience.",
    dismiss: "Got it!",
    allow: "Accept",
    deny: "Decline",
    link: "",
  }
};

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NgxStripeModule.forRoot(environment.stripeKey ?? ''),
        SharedModule,
        NgbModule,
        FontAwesomeModule,
        NgcCookieConsentModule.forRoot(cookieConfig)], providers: [
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandlerService,
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
  constructor() { }
}
